import { render, staticRenderFns } from "./BoxDemographicGroups.vue?vue&type=template&id=03b04fee&"
import script from "./BoxDemographicGroups.vue?vue&type=script&lang=js&"
export * from "./BoxDemographicGroups.vue?vue&type=script&lang=js&"
import style0 from "./BoxDemographicGroups.vue?vue&type=style&index=0&id=03b04fee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QIcon,QCardSection,QTooltip,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QIcon,QCardSection,QTooltip,QInnerLoading,QSpinnerTail})
